export default __webpack_public_path__ + "static/remix-hover-dark-b5d24f22417d1aafd8bf6cb84bf720fc.png";